import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  initials: 'MG',
  name: 'Marcos G.',
  role: 'Gerente Comercial · Buenos Aires',
  text: 'Apliqué el Tomo 02 antes de pedir mi aumento. Cambié solo la postura y el silencio después de decir el número. Me dieron un 38% más sin negociar. No lo puedo creer todavía.'
}, {
  initials: 'VR',
  name: 'Valentina R.',
  role: 'Analista Senior · Córdoba',
  text: 'Fui a 4 entrevistas sin resultados. Apliqué el protocolo del Tomo 01 y el bono de Entrevista Impecable. En la siguiente entrevista me hicieron la oferta en la misma reunión.'
}, {
  initials: 'DM',
  name: 'Diego M.',
  role: 'Director de Proyectos · Rosario',
  text: 'Tenía un colega que me pisaba en cada reunión. Con el Tomo 04 aprendí a neutralizarlo sin confrontarlo. Ahora soy yo quien dirige las conversaciones.'
}, {
  initials: 'LF',
  name: 'Luciana F.',
  role: 'Coordinadora de RRHH · Mendoza',
  text: 'El Tracker de Ascenso me mostró en números que mi influencia estaba subiendo. En 90 días pasé de coordinadora a Jefa de área. El sistema funciona.'
}, {
  initials: 'SP',
  name: 'Sebastián P.',
  role: 'Consultor Independiente · CABA',
  text: 'Triplicar mi tarifa parecía imposible. El Lenguaje del Dinero me enseñó que el problema era mi postura ante la negociación, no mi precio. Hoy cobro lo que valgo.'
}, {
  initials: 'CM',
  name: 'Carolina M.',
  role: 'Abogada Corporativa · Santa Fe',
  text: 'Presentaba ante el directorio y siempre sentía que no me tomaban en serio. El Tomo 05 cambió mi presencia por completo. Ahora me piden mi opinión antes de que hable.'
}];
export function TestimonialsSection() {
  return <section className="py-20 px-4 bg-brand-dark" data-id="element-222">
      <div className="max-w-6xl mx-auto" data-id="element-223">
        <div className="text-center mb-16" data-id="element-224">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-brand-text mb-4" data-id="element-225">
            Lo que dicen quienes ya aplicaron el sistema
          </h2>
          <p className="text-brand-gold text-lg font-medium" data-id="element-226">
            Más de 3.200 profesionales en Argentina y Latinoamérica
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-227">
          {testimonials.map((t, i) => <div key={i} className="bg-brand-black border border-brand-gold/20 p-6 rounded-xl hover:border-brand-gold/50 transition-colors flex flex-col h-full" data-id="element-228">
              <div className="flex items-center mb-4" data-id="element-229">
                <div className="w-12 h-12 rounded-full bg-brand-gold text-brand-black font-bold flex items-center justify-center text-lg mr-4 flex-shrink-0" data-id="element-230">
                  {t.initials}
                </div>
                <div data-id="element-231">
                  <h4 className="text-brand-text font-bold" data-id="element-232">{t.name}</h4>
                  <p className="text-brand-muted text-xs" data-id="element-233">{t.role}</p>
                </div>
              </div>
              <div className="flex text-brand-gold mb-4" data-id="element-234">
                {[...Array(5)].map((_, idx) => <Star key={idx} size={14} fill="currentColor" data-id="element-235" />)}
              </div>
              <p className="text-brand-text/90 text-sm leading-relaxed flex-grow italic" data-id="element-236">
                "{t.text}"
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}